import React from "react";
import ic_phone from "../../assets/images/ic-phone.svg";
import ic_telegram from "../../assets/images/ic-telegram.svg";
import ic_mail from "../../assets/images/ic-mail.svg";
import ic_webhook from "../../assets/images/ic-webhook.svg";
import _ from "lodash";
import { Col, Row } from "antd";
import { connect } from "react-redux";
import TagInput from "../TagInput";
import { startSetAlertsData } from "../../actions/auth";
import "../../styles/components/tag-input.scss";
import Loading from "../Loading";

class AlertDrawer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deactive: true,
    };
  }

  addAlert = (type, value) => {
    const alert_channels = this.props.alert_channels;
    alert_channels[type] = [...alert_channels[type], value];

    this.startSetAlertsData(alert_channels);
  };

  removeAlert = (type, id) => {
    const alert_channels = this.props.alert_channels;

    alert_channels[type] = _.compact(
      alert_channels[type].map((el) => {
        if (id !== el.id) {
          return el;
        }
        return null;
      })
    );
    this.startSetAlertsData(alert_channels);
  };

  startSetAlertsData = (data) => {
    for (var property in data) {
      if (data.hasOwnProperty(property)) {
        data[property] = data[property].map((el) => {
          return el.value;
        });
      }
    }
    this.props.startSetAlertsData(data);
  };

  componentDidMount() {
    if (this.props.email === "demo@hamravesh.com") {
      this.setState({ deactive: true });
    } else {
      this.setState({ deactive: false });
    }
  }

  render() {
    const alert_channels = this.props.alert_channels;
    return (
      <>
        {this.props.fetchInProgress && <Loading />}
        <div className="alerts-drawer">
          <Row>
            <Col span={24}>
              <TagInput
                tagIcon={ic_mail}
                label="Email address"
                channel_type="email"
                type="emails"
                color="#4073DC"
                addTag={this.addAlert}
                placeHolder="e.g: support@hamravesh.com"
                tags={alert_channels.emails}
                removeTag={this.removeAlert}
                deactive={false}
              />
            </Col>
            <Col span={24}>
              <TagInput
                tagIcon={ic_phone}
                label="Phone Number"
                channel_type="phone"
                type="phones"
                color="#FB5555"
                addTag={this.addAlert}
                placeHolder="e.g: 09121234567"
                tags={alert_channels.phones}
                removeTag={this.removeAlert}
                deactive={false}
              />
            </Col>
            <Col span={24}>
              <TagInput
                tagIcon={ic_telegram}
                label="Telegram"
                channel_type="telegram_username"
                type="telegram_usernames"
                color="#35B2FB"
                addTag={this.addAlert}
                placeHolder="e.g: hamravesh"
                tags={alert_channels.telegram_usernames}
                tagIndicator="@"
                removeTag={this.removeAlert}
                deactive={false}
              />
            </Col>
            <Col span={24}>
              <TagInput
                secondaryDark
                tagIcon={ic_webhook}
                label="Web Hook"
                channel_type="webhook"
                type="webhooks"
                color="#FF3D5A"
                addTag={this.addAlert}
                placeHolder="e.g: http://test.com/token=1234?sender=updamus"
                tags={alert_channels.webhooks}
                tagIndicator=""
                removeTag={this.removeAlert}
                deactive={false}
              />
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

const format = (object) => {
  const copiedObject = Object.assign({}, object);
  for (var property in object) {
    if (object.hasOwnProperty(property)) {
      copiedObject[property] = object[property].map((el) => {
        return { id: el.value, value: el };
      });
    }
  }
  return copiedObject;
};

const mapDispatchToProps = (dispatch) => ({
  startSetAlertsData: (data) => dispatch(startSetAlertsData(data)),
});

const mapStateToProps = (state) => ({
  alert_channels: format(state.auth.alert_channels),
  email: state.auth.email,
  fetchInProgress: state.fetchInProgress,
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertDrawer);
